import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { FileUtils, ApiUtils } from '@shared/utils';
import { PaymentApi } from '@shared/api/rest';
import { type IQueryParams, RequestStrategyEnum } from '@shared/api/models';

export const generateReceiptByIdEffect = createEffect((params: IQueryParams<string>) =>
  PaymentApi.getGenerateReceiptById(params.request, params?.signal),
);
const clearEvent = createEvent();

const $loadingStore = createStore<boolean>(false)
  .on(generateReceiptByIdEffect.pending, (_, data) => data)
  .on(generateReceiptByIdEffect.fail, () => false)
  .on(generateReceiptByIdEffect.done, () => false)
  .reset(clearEvent);

generateReceiptByIdEffect.done.watch((result) => FileUtils.downloadFile(result.result, `Deposit Payment Report - ${result.params.request}`));

generateReceiptByIdEffect.fail.watch((x) => $notificationStore.events.setError(x.error.message));

export const $generateReceiptByIdStore = {
  events: {
    effect: ApiUtils.wrapperApi(generateReceiptByIdEffect, RequestStrategyEnum.Debounce),
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
  }),
};
